export interface ResourceConfig {
  basePath?: string;
  defaultPageSize?: number;
  maxPageSize?: number;
  pageParamName?: string;
  limitParamName?: string;
  sortParamName?: string;
  defaultMediaType?: string;
  returnBodyOnCreate?: boolean;
  returnBodyOnUpdate?: boolean;
}

export const resourceConfig: ResourceConfig = {
  basePath: `api`,
};


